import { render, staticRenderFns } from "./Rent.vue?vue&type=template&id=20fe379c&lang=pug"
import script from "./Rent.vue?vue&type=script&lang=js"
export * from "./Rent.vue?vue&type=script&lang=js"
import style0 from "./Rent.vue?vue&type=style&index=0&id=20fe379c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports